import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetRosterMemberResponse,
  GetRosterMemberByIdResponse,
  PostRosterMemberResponse,
  PutRosterMemberResponse,
  PutRosterMemberStatisticsResponse,
} from '../response/roster-member';
import {
  PostRosterMemberRequest,
  PutRosterMemberRequest,
  RosterMemberStatisticsRequest,
  RosterReorderRequest,
} from '../request/roster-member';

export class RosterMemberService {
  static getRosterMembers(params?: QueryParams) {
    return apiClient.get<GetRosterMemberResponse>(buildApiUrl('/api/v1/team/roster-member'), params);
  }

  static getRosterMemberById(id: string) {
    return apiClient.get<GetRosterMemberByIdResponse>(buildApiUrl('/api/v1/team/roster-member/:id', { id }), undefined);
  }

  static postRosterMember(data: PostRosterMemberRequest) {
    return apiClient.createWithFile<PostRosterMemberResponse>(buildApiUrl('/api/v1/team/roster-member'), data);
  }

  static putRosterMember(id: string, data: PutRosterMemberRequest) {
    return apiClient.updateWithFile<PutRosterMemberResponse>(buildApiUrl('/api/v1/team/roster-member/:id', { id }), data);
  }

  static deleteRosterMember(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/team/roster-member/:id', { id }), undefined);
  }

  static putRosterMemberStatistics(id: string, data: RosterMemberStatisticsRequest) {
    return apiClient.update<PutRosterMemberStatisticsResponse>(
      buildApiUrl('/api/v1/team/roster-member/:id/statistics', { id }),
      data,
    );
  }

  static reorderRosterMembers(data: RosterReorderRequest) {
    return apiClient.update<void>(buildApiUrl('/api/v1/team/roster/reorder-members'), data);
  }
}
